<template>
  <div
    v-if="filter.type === 'autocompSingle'"
    id="order-dashboard-autocomplete"
  >
    <v-autocomplete
      class="px-2 py-1 filter-input text-start"
      dense
      v-model="filterData[`${filter.name}`]"
      :items="filter.values"
      :item-text="translateFilterItemText"
      item-value="index"
      :label="translateFilterTitle(filter.title)"
      @change="handleChange"
      single-line
      hide-details
      solo
      :menu-props="menuProps"
      menu-class="custom-autocomplete-menu"
    >
      <template v-slot:prepend-inner>
        <inline-svg class="px-1" width="26" :src="filter.icon"></inline-svg>
      </template>
    </v-autocomplete>
  </div>
  <div id="order-dashboard-select" v-else-if="filter.type === 'select2Single'">
    <v-autocomplete
      class="px-2 py-1 filter-input text-start"
      dense
      v-model="filterData[`${filter.name}`]"
      :items="filter.values"
      :item-text="translateFilterItemText"
      item-value="index"
      :label="translateFilterTitle(filter.title)"
      @change="handleChange"
      solo
      single-line
      hide-details
    >
      <template v-slot:prepend-inner>
        <inline-svg class="px-1" width="26" :src="filter.icon"></inline-svg>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: "FilterTypeNew",
  props: ["filter", "updateFunction"],
  data: () => ({
    filterData: {},
    menuProps: { maxWidth: "250px", padding: "10px", backgroundColor: "white" },
  }),
  methods: {
    normalizeFilterKey(label) {
      return String(label || "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
    },
    translateFilterTitle(title) {
      if (title == null || title === "") return "";
      const raw = String(title).trim();
      if (this.$te(raw)) return this.$t(raw);
      const normalized = this.normalizeFilterKey(raw);
      const aliasMap = {
        my_orders: "dashboard_my_orders",
      };
      const key = aliasMap[normalized] || normalized;
      if (this.$te(key)) return this.$t(key);
      return raw;
    },
    translateFilterItemText(item) {
      if (item == null) return "";
      const text = item.text != null ? String(item.text) : String(item);
      if (text === "All" && this.$te("all")) return this.$t("all");
      if (this.$te(text)) return this.$t(text);
      const normalized = this.normalizeFilterKey(text);
      if (normalized && this.$te(normalized)) return this.$t(normalized);
      return text;
    },
    handleChange() {
      this.updateFunction(this.filterData);
    },
  },
};
</script>

<style lang="scss">
.filter-input {
  .v-input__control {
    .v-input__slot {
      box-shadow: none !important;
      font-size: 10px;
      font-weight: 600;
      border-radius: 7px;
      padding: 8px;
    }
  }
}

#order-dashboard-autocomplete,
#order-dashboard-select {
  .v-label {
    font-size: 13px !important;
  }
}
</style>
